import React from 'react';
import {
  CommentOutlined,
  InstagramOutlined,
  SendOutlined,
  MessageOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';

/** آیکون و رنگ هر منبع ورودی (کلید منبع از livechat_sources.key) */
const SOURCE_ICONS = {
  widget: <GlobalOutlined />,
  bale: <CommentOutlined />,
  instagram: <InstagramOutlined />,
  telegram: <SendOutlined />,
};

export const sourceIcon = (source) => SOURCE_ICONS[source?.key] || <MessageOutlined />;

export const SourceTag = ({ source, compact = false }) => {
  if (!source) return null;
  const tag = (
    <Tag
      icon={sourceIcon(source)}
      className="custom-font"
      style={{ borderColor: source.color, color: source.color, background: 'transparent', marginInlineEnd: 0 }}
    >
      {compact ? null : source.name}
    </Tag>
  );
  return compact ? <Tooltip title={source.name}>{tag}</Tooltip> : tag;
};

/** سایت مبدأ گفتگوی ویجت (host) */
export const SiteTag = ({ site, compact = false }) => {
  if (!site) return null;
  return (
    <Tooltip title={`از سایت ${site}`}>
      <Tag icon={<GlobalOutlined />} color="cyan" className="custom-font" style={{ marginInlineEnd: 0, direction: 'ltr' }}>
        {compact && site.length > 22 ? `${site.slice(0, 20)}…` : site}
      </Tag>
    </Tooltip>
  );
};

export const OPERATOR_STATUS = {
  online: { label: 'آنلاین', color: 'green' },
  away: { label: 'غایب', color: 'gold' },
  offline: { label: 'آفلاین', color: 'default' },
};

export const STRATEGY_LABELS = {
  least_busy: 'کم‌مشغله‌ترین اپراتور',
  round_robin: 'نوبتی (Round Robin)',
};

export const contactName = (contact) =>
  contact?.name ||
  (contact?.username ? `@${contact.username}` : contact?.phone || `بازدیدکننده #${contact?.id ?? ''}`);

export const operatorName = (operator) => operator?.display_name || operator?.user?.name || '—';

/** زمان نسبی کوتاه فارسی */
export const formatChatTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const now = new Date();
  const sameDay = date.toDateString() === now.toDateString();
  return sameDay
    ? date.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })
    : date.toLocaleDateString('fa-IR', { month: 'short', day: 'numeric' }) +
        ' ' +
        date.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' });
};

/** ساعت پیام (تاریخ در جداکننده روز نمایش داده می‌شود) */
export const formatMessageTime = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' });
};

/** تاریخ و ساعت کامل (راهنمای روی ساعت پیام) */
export const formatFullTime = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('fa-IR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

/** برچسب جداکننده روز: امروز، دیروز یا تاریخ */
export const formatDayLabel = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  if (date.toDateString() === today.toDateString()) return 'امروز';
  if (date.toDateString() === yesterday.toDateString()) return 'دیروز';
  const options = { weekday: 'long', month: 'long', day: 'numeric' };
  if (date.getFullYear() !== today.getFullYear()) options.year = 'numeric';
  return date.toLocaleDateString('fa-IR', options);
};

/** ترتیب زمانی پیام‌ها؛ پیام‌های قدیمی واردشده (تاریخچه اینستاگرام) شناسه بزرگ‌تر ولی زمان قدیمی‌تر دارند */
export const sortMessages = (list) =>
  [...list].sort((a, b) => new Date(a.created_at) - new Date(b.created_at) || a.id - b.id);

export const LIVECHAT_SOCKET_EVENTS = {
  message: 'livechat_message',
  conversation: 'livechat_conversation',
};
